// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not-download{font-weight:700;background-color:#f0f0f0}.wrap-pre{white-space:pre-wrap;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
